import styled, { css } from 'styled-components';
import { Form } from 'components/atoms/form';
import { Input as InputAtom } from 'components/atoms/input';
import { TertiaryButton } from 'components/atoms/tertiary-button';

export const Heading = styled.h6`
  margin-bottom: var(--layout-01);
`;
export const Box = styled.div`
  width: 200px;
  height: 248px;
  padding: var(--spacing-06);
  background-color: var(--coolest-gray-10);
  box-shadow: var(--shadow-02);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  transition: box-shadow 0.3s ease-in-out;
  cursor: pointer;

  ${({ active }: { active?: boolean }) =>
    active &&
    css`
      background-color: var(--primary-color);
      color: var(--white-100);
    `};

  &:hover {
    box-shadow: var(--shadow-16);
  }
`;

export const EmbedWrapper = styled.div`
  background-color: var(--coolest-gray-10);
  box-shadow: var(--shadow-02);
  width: 648px;
  height: 208px;
  padding: var(--spacing-07) var(--spacing-10);
`;

export const StyledForm = styled(Form)`
  margin-top: var(--layout-01);
  .ant-form-item {
    margin-right: 0;
  }
`;

export const StyledFormItem = styled(Form.Item)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  &&.ant-form-item {
    margin-right: var(--spacing-03);
  }
`;

export const SubmitButton = styled(TertiaryButton)`
  display: flex;
  flex-direction: row-reverse;
  padding-right: var(--spacing-05);
  & > svg {
    margin-right: 0;
    margin-left: var(--layout-01);
  }
  margin-top: var(--spacing-07);

  > .ant-btn-loading-icon {
    padding-left: var(--spacing-03);
  }
`;

export const Input = styled(InputAtom)`
  width: 392px;
`;
